import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('INVENTORY_REPORT', [
    'VIEW',
    'INFO',
    'HEADER',
    'FILTER_FORM',
    'EXPORT'
])
